import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import {Angular2TokenService } from 'angular2-token';
import { Router , ActivatedRoute} from '@angular/router';
import { ProfileService } from '../../../platform/profile/profile/profile.service';
declare var $:any;

@Component({
 selector: 'app-cus-change-password',
  templateUrl: './cus-change-password.component.html',
  styleUrls: ['./cus-change-password.component.css'],

  providers:[ProfileService]
})
export class CusChangePasswordComponent implements OnInit {

  email:string;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private profileService: ProfileService
  ) { }

   submitted = false;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
   passwordmatchFlag =false;
   CustId;
   changePasswordForm = this.formBuilder.group({
     password: new FormControl('',[Validators.required,Validators.minLength(8)]),
     password_confirmation : new FormControl('',Validators.required)
   });

   onSubmit(data) {
    this.submitted = true;
    if(data.password_confirmation == data.password) {
      this.passwordmatchFlag = false;
      data['email']=this.email;
      data['id']=this.CustId;
      this.profileService.changePassword(data)
      .subscribe(
          result => {
            this.successalert = true;
            this.successMessage = "Password changed successfully. Logout and Login Again !!";
            setTimeout(function() {
                    this.successalert = false;
              }.bind(this), 100000);
          //    $.notify('Password changed successfully. Logout and Login Again!')
          },
          error => {
            this.erroralert = true;
            this.errorMessage=JSON.parse(error['_body']).message;
            setTimeout(function() {
                     this.erroralert = false;
                }.bind(this), 5000);
            return Observable.throw(error);
          }
      );
    }
    else {
      this.passwordmatchFlag = true;
    }
  }
  matchpasswords(val){
    if(val== this.changePasswordForm.value.password) {
      this.passwordmatchFlag = false;
    } else{
      this.passwordmatchFlag = true;
    }
  }
  onFocusFunction(){
    this.passwordmatchFlag = false;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
              this.email = params['email'];
              this.CustId = params['custId'];
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/platform/customer/cus-change-password/cus-change-password.component.ts